import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=236add38"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"
import style0 from "./Header.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/app/components/base/Icon/Icon.vue').default,LinkComponent: require('/app/components/base/LinkComponent/LinkComponent.vue').default,LanguageSwitch: require('/app/components/base/LanguageSwitch/LanguageSwitch.vue').default,NavInline: require('/app/components/base/NavInline/NavInline.vue').default,Modal: require('/app/components/base/Modal/Modal.vue').default,Headline: require('/app/components/base/Headline/Headline.vue').default,Header: require('/app/components/app/Header/Header.vue').default})
